export const BASE_API_URL = 'https://api.themoviedb.org/3';
export const BASE_YT_URL = 'https://www.youtube.com/watch?v=';
